var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-card', [_c('ul', {
    staticClass: "main",
    attrs: {
      "id": "myUL"
    }
  }, _vm._l((_vm.projectRoles), function(project_obj, index) {
    return _c('li', {
      attrs: {
        "id": ""
      }
    }, [_c('span', {
      staticClass: "caret projects"
    }, [_vm._v(_vm._s(project_obj.projectname))]), _vm._v(" "), _c('ul', {
      staticClass: "nested"
    }, _vm._l((project_obj.role), function(role_obj, index) {
      return _c('li', {
        attrs: {
          "id": ""
        }
      }, [_c('span', {
        staticClass: "caret roles"
      }, [_vm._v(_vm._s(role_obj.rolename))]), _vm._v(" "), (role_obj.description) ? _c('small', {
        attrs: {
          "id": role_obj.roleid
        }
      }, [_vm._v("\n                 <" + _vm._s(role_obj.description) + ">\n              ")]) : _vm._e(), _vm._v(" "), _c('ul', {
        staticClass: "nested active"
      }, _vm._l((role_obj.permissions), function(permissions_obj, index) {
        return (permissions_obj.parentid == 0) ? _c('li', {
          attrs: {
            "id": permissions_obj.permissionid
          }
        }, [(permissions_obj.ismenu == true) ? _c('span', {
          staticClass: "caret",
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v(_vm._s(permissions_obj.permissionname) + _vm._s(permissions_obj.ismen))]) : _c('span', {
          staticClass: "caret",
          staticStyle: {
            "color": "blue"
          }
        }, [_vm._v(_vm._s(permissions_obj.permissionname))]), _vm._v(" "), _c('ul', {
          staticClass: "nested active"
        }, _vm._l((role_obj.permissions), function(perms_obj, index) {
          return (perms_obj.parentid == permissions_obj.permissionid) ? _c('li', {
            attrs: {
              "id": perms_obj.permissionid
            }
          }, [(perms_obj.ismenu == true) ? _c('span', {
            staticClass: "caret",
            staticStyle: {
              "color": "red"
            }
          }, [_vm._v(_vm._s(perms_obj.permissionname))]) : _c('span', {
            staticClass: "caret",
            staticStyle: {
              "color": "blue"
            }
          }, [_vm._v(_vm._s(perms_obj.permissionname))]), _vm._v(" "), _c('ul', {
            staticClass: "nested active"
          }, _vm._l((role_obj.permissions), function(perms_obj2, index) {
            return (perms_obj2.parentid == perms_obj.permissionid) ? _c('li', {
              attrs: {
                "id": perms_obj2.permissionid
              }
            }, [(perms_obj2.ismenu == true) ? _c('span', {
              staticClass: "caret",
              staticStyle: {
                "color": "red"
              }
            }, [_vm._v(_vm._s(perms_obj2.permissionname))]) : _c('span', {
              staticClass: "caret",
              staticStyle: {
                "color": "blue"
              }
            }, [_vm._v(_vm._s(perms_obj2.permissionname))]), _vm._v(" "), _c('ul', {
              staticClass: "nested active"
            })]) : _vm._e()
          }))]) : _vm._e()
        }))]) : _vm._e()
      }))])
    }))])
  }))])], 1), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "active": _vm.show,
      "duration": "0.6",
      "spinner": "bar-fade-scale",
      "color": "#FF6700"
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-760b2288","hasScoped":true}!./src/views/components/projectroleaccessview/projectroleaccessview.component.html
// module id = 835
// module chunks = 1